// extracted by mini-css-extract-plugin
export default {"title":"notfound_title__6rf6s"};